import React from "react";
import point from "./assets/images/point.svg";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./assets/styles/popover.styles";
import CloseIcon from "@material-ui/icons/Close";
import Fade from "@material-ui/core/Fade";
import Popper from "@material-ui/core/Popper";
import { useState, useEffect } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

const useStyles = makeStyles(styles);

export default function PopoverElem({
  primaryDimension,
  secondaryDimension,
  color,
  x,
  y,
  open,
  name,
  handleOpen,
  handleClose,
  anchorEl,
}) {
  const props = { x, y, open };
  const classes = useStyles(props);
  const [stateOpen, setState] = useState(false);
  useEffect(() => {
    if (!stateOpen) handleClose(name);
  }, [stateOpen]);
  return (
    <span className={classes.root}>
      <ClickAwayListener
        onClickAway={() => {
          console.log(stateOpen);
          stateOpen ? setState(false) : setState(true);
        }}
      >
        <Popper
          open={open}
          anchorEl={anchorEl}
          modifiers={{
            offset: {
              enabled: true,
              offset: "0,-60",
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: "viewport",
            },
          }}
          placement="left"
          transition
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <span className={classes.popoverWrap}>
                <CloseIcon
                  style={{ zIndex: 99 }}
                  className={classes.close}
                  onClick={() => {
                    handleClose(name);
                    setState(false);
                  }}
                />
                <span className={classes.contentWrap}>
                  <p className={classes.primary}>{primaryDimension}</p>
                  <p className={classes.secondary}>{secondaryDimension}</p>
                  {/* <p className={classes.color} >Colore <strong className={classes.strong} >{color}</strong></p> */}
                </span>
              </span>
            </Fade>
          )}
        </Popper>
      </ClickAwayListener>
      <img
        src={point}
        className={classes.point}
        alt="point"
        onClick={(e) => handleOpen(e, name)}
      />
    </span>
  );
}
